import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import axios from 'axios';
import { API_BASE_URL, ENDPOINTS } from '../../config';
import 'notyf/notyf.min.css';
import { Notyf } from 'notyf';
import './Sidebar.css';
const notyf = new Notyf({
  position: {
    x: 'right',
    y: 'top'
  },
  ripple: true,
  dismissible: true,
});

export default function Sidebar() {
  const [, , removeCookie] = useCookies(["user"]);
  const navigate = useNavigate();
  const [chats, setChats] = useState([]);
  const [cookies] = useCookies(['token']);
  const [isLoading, setIsLoading] = useState(true);
  const handleLogout = () => {
    removeCookie("token");
    navigate("/login");
  };
  const sidebarRef = useRef(null);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const saved = localStorage.getItem('aikit-sidebar-collapsed');
    return saved === null ? false : saved === 'true';
  });
  const fetchChatsdata = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}${ENDPOINTS.CHATS.GET_ALL}`,
        {
          headers: {
            Authorization: `Bearer ${cookies.token}`
          }
        }
      );
      setChats(response.data);
    } catch (err) {
      notyf.error(err.response?.data?.detail || 'Failed to load chat history');
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const fetchChats = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}${ENDPOINTS.CHATS.GET_ALL}`,
          {
            headers: {
              Authorization: `Bearer ${cookies.token}`
            }
          }
        );
        setChats(response.data);
      } catch (err) {
        notyf.error(err.response?.data?.detail || 'Failed to load chat history');
      } finally {
        setIsLoading(false);
      }
    };

    if (cookies.token) {
      fetchChats();
    }

    const handleChatsUpdate = () => fetchChats();
    window.addEventListener("chatsUpdated", handleChatsUpdate);

    return () => window.removeEventListener("chatsUpdated", handleChatsUpdate);
  }, [cookies.token]);
  // Handle outside click 
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (window.innerWidth <= 991 && sidebarVisible) {
        if (
          sidebarRef.current &&
          !sidebarRef.current.contains(e.target) &&
          !e.target.closest('#mobileSidebarToggle')
        ) {
          setSidebarVisible(false);
        }
      }
    };

    window.addEventListener('click', handleOutsideClick);
    return () => window.removeEventListener('click', handleOutsideClick);
  }, [sidebarVisible]);

  const startNewChat = async (title) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}${ENDPOINTS.CHATS.CREATE}`,
        { title: title, messages: [{ content: '', sender: '' }] },
        { headers: { Authorization: `Bearer ${cookies.token}` } }
      );
      navigate(`/c/${response.data.chat_id}`);
      fetchChatsdata();
    } catch (err) {
      notyf.error('Failed to create new chat');
    }
  };

  // Apply/remove collapsed class
  useEffect(() => {
    document.body.classList.toggle('sidebar-collapsed', sidebarCollapsed);
  }, [sidebarCollapsed]);

  //  toggle methods globally for Header 
  useEffect(() => {
    window.__setSidebarVisible = () => {
      setSidebarVisible((prev) => !prev);
    };
    window.__toggleSidebarCollapsed = () => {
      const newState = !sidebarCollapsed;
      setSidebarCollapsed(newState);
      localStorage.setItem('aikit-sidebar-collapsed', newState);
    };
  }, [sidebarCollapsed]);

  return (
    <nav
      ref={sidebarRef}
      id="sidebar"
      className={`sidebar ${sidebarVisible ? 'show' : ''} ${sidebarCollapsed ? 'collapsed' : ''}`}
    >
      <div className="sidebar-header">
        <button className="sidebar-toggle d-lg-none" onClick={() => setSidebarVisible(false)}>
          <i className="fas fa-times"></i>
        </button>
      </div>

      <div className="sidebar-menu">
        <div className="menu-section">
          <ul className="menu-items">
            <li className="menu-item">
              <Link
                className="menu-link active"
                onClick={() => startNewChat('New Chat')}
              >
                <i className="fa-regular fa-comment menu-icon"></i>
                <span className="menu-text">New Chat</span>
              </Link>

            </li>
            {/* <li className="menu-item">
              <Link to="/history" className="menu-link">
                <i className="fas fa-chart-line menu-icon"></i>
                <span className="menu-text">History</span>
              </Link>
            </li> */}
          </ul>
        </div>
        <hr />
        <div className="menu-section history-menu">
          <div className="menu-section-title">Recent Searches</div>
          <ul className="menu-items sear">
            {chats.map((chat) => (
              <li key={chat.chat_id} className="menu-item">
                <Link to={`/c/${chat.chat_id}`} className="menu-link">
                  <span
                    className="menu-text"
                    title={chat.messages[1]?.content || chat.title} // show full text on hover
                  >
                    {(() => {
                      const text = chat.messages[1]?.content || chat.title || "";
                      const words = text.trim().split(/\s+/);
                      return words.length > 4
                        ? words.slice(0, 4).join(" ") + "..."
                        : text;
                    })()}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <hr />
        <div className="menu-section side-men-botom">
          <ul className="menu-items">
            <li className="menu-item">
              <Link to="/settings" className="menu-link">
                <i class="fa-solid fa-gear menu-icon"></i>
                <span className="menu-text">Settings</span>
              </Link>
            </li>
            <li className="menu-item" onClick={handleLogout}>
              <Link to="" className="menu-link">
                <i class="fas fa-sign-out-alt menu-icon"></i>
                <span className="menu-text">Log out</span>
              </Link>
            </li>
          </ul>
        </div>

      </div>
    </nav>
  );
}
